import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from '@auth-suite-services/services';

const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboards/dashboard1',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.module').then(
            (m) => m.UicomponentsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.module').then((m) => m.FormModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.module').then((m) => m.ChartsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.module').then((m) => m.AppsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.module').then((m) => m.WidgetsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.module').then((m) => m.TablesModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.module').then(
            (m) => m.ThemePagesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'noticeboard',
        loadChildren: () =>
          import('./noticeboard/noticeboard.module').then(
            (m) => m.NoticeBoardModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'auth0',
        loadChildren: () => import('./auth0/auth0.module').then(m => m.Auth0Module),
        // loadChildren: './auth0/auth0.module#Auth0Module',
        canActivate: [ AuthGuard ]
      },

      {
        path: 'sms',
        loadChildren: () => import('./sms/sms.module').then((m) => m.SmsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'mad',
        loadChildren: () =>
          import('./merchantadmin/merchantadmin.module').then(
            (m) => m.MerchantAdminModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'device',
        loadChildren: () =>
          import('./device/device.module').then((m) => m.DeviceModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'portal',
        loadChildren: () =>
          import('./portal/portal.module').then((m) => m.PortalsModule),
        canActivate: [AuthGuard],
      },
      // Profile browse lazy route 28/10/2026 DW
      {
        path: 'profile',
        loadChildren: () =>
          import('./profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'access',
        loadChildren: () =>
          import('./access/access.module').then((m) => m.AccessModule),
        // loadChildren: './access/access.module#AccessModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'pli',
        loadChildren: () =>
          import('./product-list/product-list.module').then(
            (m) => m.ProductListModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./settings/settings.module').then(
            (m) => m.SettingsModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.module').then(
            (m) => m.LandingPageModule
          ),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.module').then(
            (m) => m.LandingPageModule
          ),
      },
    ],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  { path: '**', redirectTo: '' },
  // {
  //   path: '**',
  //   redirectTo: 'authentication/error',
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
